
import React, { useEffect, useState } from 'react';

import { Button, Container, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getProductInfos, setProductCurrentStep, setProductInfo, useCreateProductStepThreeMutation, useRelatedProductByIDQuery } from '../../../Redux/ProductSlice';
import ProductRelatedNew from './ProductRelatedNew';
import RelatedProductsModal from './RelatedProductsModal';




const StepThreeProduct = ({ productList }) => {
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const getProducInfo = useSelector(getProductInfos);
    const productId = getProducInfo?.id || getProducInfo?.productId
    const [show, setShow] = useState(false);
    const [deleteShow, setdeleteShow] = useState(false);
    const [deleteselectedID, setdeleteselectedID] = useState([]);
    const [finalproductlist, setFinalProductList] = useState([]);

    const handleClose = () => {
        setShow(false)
    };

    const handleShow = () => {
        setShow(true)
    };

    // const [selectedRows, setSelectedRows] = useState([]);


    // useEffect(() => {
    //     if (pathname.includes('product-edit')) {
    //         setSelectedRows(getProducInfo?.basicRelatedProducts?.map(it => ({ ...it, id: it?.relatedProductId })))
    //     }
    // }, [pathname])


    // const handleCheckboxChange = (row) => {
    //     const isSelected = selectedRows.some((r) => r?.id === row?.id);
    //     if (isSelected) {
    //         setSelectedRows(selectedRows.filter((r) => r?.id !== row?.id));
    //     } else {
    //         setSelectedRows([...selectedRows, row]);
    //     }
    // };

    const [createProductFn, { data, isSuccess: createSuceess, error: createErr, isLoading: createLoading }] = useCreateProductStepThreeMutation();
    const [isExit, setIsExit] = useState(false);
    let filteredRelatedProducts = [];


    // function handleClickSubmit() {
    //     if (finalproductlist && deleteselectedID.length > 0) {
    //         filteredRelatedProducts = finalproductlist.filter(id => !deleteselectedID.includes(id));
    //         setFinalProductList(filteredRelatedProducts)
    //     }
    //     setdeleteShow(!deleteShow)
    //     handleCheckboxChange(filteredRelatedProducts)
    // }



    // useEffect(() => {
    //     let relatedProduct = [];
    //     selectedRows?.map((it) =>
    //         relatedProduct.push(it.id)
    //     )
    //     setFinalProductList(relatedProduct)

    // }, [selectedRows]);


    useEffect(() => {
        if (createSuceess) {
            const message = data?.message || "Product created successfully";
            toast.success(message);
            // dispatch(setProductInfo({ productId: data?.response }))
            // setProductId(data?.response)

            // dispatch(setProductInfo({ relatedProducts: selectedRows }))
            dispatch(setProductInfo({ relatedProducts: [] }))
            // setProductId(data?.response)
            // reset()
            // setProductStep('STEP2')


            if (!isExit) {
                dispatch(setProductCurrentStep('STEP4'))



            } else {
                navigate('/products-list')
            }


        }
        if (createErr) {
            if ('data' in createErr) {
                const errorData = createErr;
                toast.error(errorData.data.message);

            }
        }
    }, [data, createSuceess, createErr]);
    const [allListProducts, setAllListProducts] = useState({});
    const [relatedListProducts, setRelatedListProducts] = useState([]);
    const [modalselectedRelatedIds, setModalSelectedRelatedIds] = useState([]);
    const [selectedRelatedIds, setSelectedRelatedIds] = useState([]);
    const { data: productListData } = useRelatedProductByIDQuery(getProducInfo?.id, { skip: !getProducInfo?.id });


    useEffect(() => {
        if (getProducInfo?.productId || getProducInfo?.id) {

            if (productListData?.response?.
                basicRelatedProducts?.length > 0) {

                const relatedFromDB = productListData?.response?.basicRelatedProducts?.map(pd => ({
                    ...pd?.relatedProduct,
                    ProductImageColourCombinations
                        : [{ image: [{ preview: pd?.relatedProduct?.ProductImageColourCombinati?.[0]?.preview }] }]
                })) || []
                setRelatedListProducts(relatedFromDB);
                setModalSelectedRelatedIds(relatedFromDB?.map(it => it?.id))
                // setdeleteselectedPro(getProducInfo?.basicRelatedProducts?.map(pd => pd?.relatedProduct) || []?.map(it => it?.id));
            }
        }
    }, [getProducInfo?.productId, getProducInfo?.id, productListData]);

    return (
        <React.Fragment>

            <ProductRelatedNew
                allListProducts={allListProducts}
                setAllListProducts={setAllListProducts}
                selectedRelatedIds={selectedRelatedIds}
                setSelectedRelatedIds={setSelectedRelatedIds}
                handleShow={handleShow}
                relatedListProducts={relatedListProducts}
                setRelatedListProducts={setRelatedListProducts}
                deleteselectedID={deleteselectedID}
                setdeleteselectedID={setdeleteselectedID} setdeleteShow={setdeleteShow} deleteShow={deleteShow}
                data={productList?.response?.filter(it => finalproductlist?.includes(it?.id))} />


            {/* product list to select */}
            <Modal
                show={show}
                onHide={() => setShow(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Related Products
                    </Modal.Title>



                </Modal.Header>
                <Modal.Body>
                    {/* <ProductTableList handleCheckboxChange={handleCheckboxChange} selectedRows={selectedRows} setSelectedRows={setSelectedRows} handleShow={handleShow} data={productList?.response?.filter(pd => pd?.id !== productId)} /> */}
                    <RelatedProductsModal
                        allListProducts={allListProducts}
                        setAllListProducts={setAllListProducts}
                        modalselectedRelatedIds={modalselectedRelatedIds}
                        setModalSelectedRelatedIds={setModalSelectedRelatedIds}

                        handleShow={handleShow}
                        relatedListProducts={relatedListProducts}
                        setRelatedListProducts={setRelatedListProducts}
                        deleteselectedID={deleteselectedID}
                        setdeleteselectedID={setdeleteselectedID} setdeleteShow={setdeleteShow} deleteShow={deleteShow}
                        data={productList?.response?.filter(it => finalproductlist?.includes(it?.id))} />

                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={() => {
                            const allProducts = Object.values(allListProducts).flatMap(it => it)
                            setRelatedListProducts(Object.values(allListProducts).map(it => it)?.filter(it => modalselectedRelatedIds?.includes(it?.id)))
                            // setRelatedListProducts(modalselectedRelatedIds?.map(it=> allProducts?.find(pd=>pd?.id==it)))
                            setShow(false)
                        }}
                    >Submit</Button>
                    <Button onClick={handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>

            {/* Remove */}
            <Modal
                show={deleteShow}
                onHide={() => setdeleteShow(!deleteShow)}
                size="l"
                aria-labelledby="contained-modal-title-vcenter"
                top="true"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Remove Products
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure to remove selected products?
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={() => {
                            const filterIds = relatedListProducts?.filter(it => !selectedRelatedIds?.includes(it?.id))
                            setRelatedListProducts(filterIds);
                            setSelectedRelatedIds([]);
                            setModalSelectedRelatedIds(filterIds?.map(it => it?.id))
                            setdeleteShow(false)
                        }}
                    >Submit</Button>
                    <Button onClick={() => setdeleteShow(!deleteShow)}>Close</Button>
                </Modal.Footer>
            </Modal>
            {/* Buttons */}
            <Container fluid>


                <div className="d-flex">
                    <div>
                        <button className="btn btn-primary shadow-lg rounded" onClick={() => {
                            dispatch(setProductCurrentStep('STEP3'))

                        }}>Previous</button>
                    </div>
                    <div className="ms-auto">
                        <button className="btn btn-info shadow-lg rounded" type='submit' onClick={() => {
                            setIsExit(true)
                        }}>Draft & Exit</button>
                        <button className="btn  btn-danger shadow-lg rounded ms-2" onClick={() => navigate('/products-list')}>Cancel</button>

                        <button className="btn btn-secondary shadow-lg rounded ms-2" type='button' onClick={() => {
                            createProductFn({ productId, relatedProducts: relatedListProducts?.map(it => it?.id) })
                            setIsExit(true)
                        }} >Next</button>
                    </div>
                </div>
            </Container>

        </React.Fragment >
    );
};

export default StepThreeProduct;
